import React, { Component } from 'react';

import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Box, Button, Chip, Dialog, DialogContent, DialogTitle, Divider, Grid } from '@mui/material';
import Global from './Global';
import { CalendarMonth, CalendarToday } from '@mui/icons-material';
import DateRangePicker from './DateRangePicker';

class DateRangePickerRich extends Component {
  state = { 
    showDialog: false, 
    startDate: moment(),
    endDate: moment(),
    lastYear: [moment().subtract(1, 'year').startOf("year"), moment().subtract(1, "year").endOf("year")],
    thisYear: [moment().startOf('year'), moment().endOf("year")],
    lastMonth: [moment().subtract(1, 'month').startOf("month"), moment().subtract(1, "month").endOf("month")],
    thisMonth: [moment().startOf('month'), moment().endOf("month")],
    lastWeek: [moment().subtract(1, 'week').startOf("week"), moment().subtract(1, "week").endOf("week")],
    thisWeek: [moment().startOf('week'), moment().endOf("week")],
    yeterday: [moment().subtract(1, 'day'), moment().subtract(1, "day")],
    today: [moment(), moment()],
  } 

  showDialog = () => {
    this.setState({showDialog: true});
  }

  hideDialog = () => {
    this.setState({showDialog: false});
  }

  componentDidMount() {
    this.setState({startDate: this.props.startDate, endDate: this.props.endDate});
  }

  // componentDidUpdate(prevProps, prevState) {
  //   console.log("PREVPROPS", prevProps, "PREVSTATE", prevState);
  // }

  add1Day = () =>{
    this.handleDateChanged([this.state.startDate, this.state.endDate.add(1, "day")]);
    // this.setState({endDate: this.state.endDate.add(1, "day")}, () => {
    //   this.props.onDateChanged([this.state.startDate, this.state.endDate]);
    // });
  }

  sub1Day = () =>{
    this.handleDateChanged([this.state.startDate.subtract(1, "day"), this.state.endDate]);
    // this.setState({startDate: this.state.startDate.subtract(1, "day")}, () => {
    //   this.props.onDateChanged([this.state.startDate, this.state.endDate]);
    // });
  }

  handleDateChanged = (newDateRange) => {
    if(!newDateRange[0] || !newDateRange[1]){
      return;
    }
    console.log("NEWDATERANGE", newDateRange);

    let startDate = newDateRange[0];
    let endDate = newDateRange[1];

    if(!startDate.isAMomentObject){
      startDate = moment(startDate);
    }

    if(!endDate.isAMomentObject){
      endDate = moment(endDate);
    }

    this.setState({startDate: startDate, endDate: endDate}, () => {
      this.props.onDateChanged([this.state.startDate, this.state.endDate]);
      this.hideDialog();
    })
  }

  render() {
    const presets = [
      { label: "Today", value: this.state.today },
      { label: "Yesterday", value: this.state.yeterday },
      { label: "This Week", value: this.state.thisWeek },
      { label: "Last Week", value: this.state.lastWeek },
      { label: "This Month", value: this.state.thisMonth },
      { label: "Last Month", value: this.state.lastMonth },
      { label: "This Year", value: this.state.thisYear },
      { label: "Last Year", value: this.state.lastYear },
    ];

    return (
      <Box>
        <Box
          onClick={this.showDialog}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "8px",
            padding: "6px 12px",
            textAlign: "center",
            cursor: "pointer",
            bgcolor: "background.paper",
            transition: "all 0.2s ease",
            "&:hover": {
              borderColor: "primary.main",
              bgcolor: "action.hover",
            },
          }}
        >
          <CalendarToday sx={{ fontSize: 15, color: "primary.main" }} />
          <Box sx={{ fontSize: 13, fontWeight: 600, whiteSpace: "nowrap" }}>
            {Global.formatDateTimeToStrFormat(this.state.startDate, "DD-MM-yyyy")} - {Global.formatDateTimeToStrFormat(this.state.endDate, "DD-MM-yyyy")}
          </Box>
        </Box>

        <Dialog fullWidth maxWidth="xs" onClose={this.hideDialog} open={this.state.showDialog}>
          <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CalendarMonth color="primary" fontSize="small" />
            {this.props.title ?? "Setup Date"}
          </DialogTitle>
          <DialogContent>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={1}>
              {presets.map((preset) => (
                <Grid item xs={6} key={preset.label}>
                  <Button
                    size="small"
                    fullWidth
                    variant="outlined"
                    color="primary"
                    sx={{ textTransform: "none", borderRadius: "8px" }}
                    onClick={() => this.handleDateChanged(preset.value)}
                  >
                    {preset.label}
                  </Button>
                </Grid>
              ))}
              <Grid item xs={12}>
                <Divider sx={{ mt: 2, mb: 1.5 }}>
                  <Chip label="Custom" size="small" />
                </Divider>
                <DateRangePicker {...this.props} onDateChanged={this.handleDateChanged} />
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </Box>
    );
  }
}
 
export default DateRangePickerRich;

// function DateRangePickerRichFunction(props){
//     const [dateRange, setDateRange] = React.useState([props.startDate, props.endDate]);
//     const [startDate, endDate] = dateRange;
//     const [message, setMessage] = React.useState("");

//     if(true){
//       return <Box>{startDate} - {endDate}</Box>
//     }

//     return (

//       <>
//         <DatePicker
//           readOnly={false}
//           selectsRange={true}
//           startDate={startDate}
//           endDate={endDate}
//           dateFormat="d-M-yyyy"
//           placeholderText='Filter tanggal'
//           onChange={(update) => {
//             console.log("RANGE", update);
            
//             // if(update[0] !== null && update[1] !== null){
//             //   let startDate = moment(update[0]);
//             //   let endDate = moment(update[1]);
//             //   let diffs = Math.abs(startDate.diff(endDate, "days"));
//             //   console.log("DIFFS", diffs);
//             //   if(diffs > 35){
//             //     setDateRange([null, null]);
//             //     setMessage("Rentang tanggal max 35 hari");
//             //     return
//             //   }
//             // }
            
//             setDateRange(update);
//             setMessage("");
//             // if(update[0] !== null && update[1] !== null){
//               props.onDateChanged(update);
//             // }

//           }}
//           isClearable={true}
//           popperPlacement="top-end"
//           popperModifiers={[
//             {
//               name: "offset",
//               options: {
//                 offset: [5, 10],
//               },
//             },
//             {
//               name: "preventOverflow",
//               options: {
//                 rootBoundary: "viewport",
//                 tether: false,
//                 altAxis: true,
//               },
//             },
//           ]}
//           className='border rounded rounded-lg border-secondary p-2 text-center'
//         />
//         <div className="text-danger">
//           {message}
//         </div>
//       </>
//     );
//   }

  // export default DateRangePickerRich;